export default __webpack_public_path__ + "static/media/psc-rep-dig.9823eda6.jpg";